document.addEventListener("DOMContentLoaded", function () {
  // Gestion des boutons +/-
  const minusBtn = document.querySelector(".qty-minus");
  const plusBtn = document.querySelector(".qty-plus");
  const qtyInput = document.getElementById("product-quantity");
  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener("click", () => {
      let val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
    plusBtn.addEventListener("click", () => {
      let val = parseInt(qtyInput.value, 10);
      let max = parseInt(qtyInput.getAttribute("max"), 10) || 999;
      if (val < max) qtyInput.value = val + 1;
    });
    // Empêche les valeurs non numériques
    qtyInput.addEventListener("change", function () {
      let val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      let max = parseInt(this.getAttribute("max"), 10) || 999;
      if (val > max) this.value = max;
    });
  }

  // Ajout au panier
  const addBtn = document.getElementById("custom-add-to-cart-btn");
  if (addBtn) {
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let variantId = getCurrentVariantId();
      if (!variantId) {
        showMessage(
          "Erreur : sélectionnez une variante (taille/couleur)",
          "red",
        );
        return;
      }
      let quantity = parseInt(
        document.getElementById("product-quantity").value,
        10,
      );
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200 || data.id) {
            showMessage("✓ Ajouté au panier !", "green");
            updateCartCount();
            updateCartCountDisplay(); // <-- Met à jour le compteur dans le header
          } else {
            showMessage(
              "Erreur : " + (data.description || "Veuillez réessayer"),
              "red",
            );
          }
        })
        .catch(() => showMessage("Erreur technique", "red"));
    });
  }

  function getCurrentVariantId() {
    // Essayer plusieurs sélecteurs communs dans Xtra
    let idField =
      document.querySelector('[name="id"]') ||
      document.querySelector('input[name="id"]:not([type="hidden"])') ||
      document.querySelector('.product-form__input input[name="id"]');
    if (idField && idField.value) return idField.value;
    // Si Xtra utilise des attributs data sur les boutons de variante
    let selectedVariant = document.querySelector(
      '.variant-input__button[aria-selected="true"]',
    );
    if (selectedVariant && selectedVariant.dataset.variantId)
      return selectedVariant.dataset.variantId;
    return null;
  }

  function showMessage(msg, color) {
    const msgDiv = document.querySelector(".atc-message");
    if (msgDiv) {
      msgDiv.textContent = msg;
      msgDiv.style.color = color;
      setTimeout(() => {
        msgDiv.textContent = "";
      }, 3000);
    }
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        document
          .querySelectorAll(
            ".cart-count, .js-cart-count, .site-header__cart-count",
          )
          .forEach((el) => (el.textContent = cart.item_count));
      });
  }
  function updateCartCountDisplay() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const countSpan = document.getElementById("cart-item-count");
        if (countSpan) {
          countSpan.textContent = cart.item_count;
        }
      })
      .catch((error) => console.error("Erreur mise à jour panier:", error));
  }
});

// On sélectionne tous les boutons ayant la classe 'overlay-buy_button'

// const buyButtons = document.querySelectorAll(".overlay-buy_button");
// console.log(buyButtons);
// buyButtons.forEach((button) => {
//   // .trim() permet d'ignorer les espaces et retours à la ligne autour du texte
//   if (button.textContent.trim() === "Options d'affichage") {
//     button.textContent = "Ajouter au panier";
//   }
// });
